import { useGetDemoQuery } from '@carboncopyco/data';
import { RecordingTypes } from '@carboncopyco/types';
import { Button, LoadingDots } from '@carboncopyco/ui';
import { useNavigate, useParams } from 'react-router-dom';
import ErrorPage from '../components/ErrorPage';
import WorkspaceLayout from '../components/Workspaces/WorkspaceLayout';
import { useCustomNavigate } from '../hooks/useCustomNavigate';
import { DemoScreen } from '../routes/DemoPage/DemoPage';
import { useUser } from '../store/context';
import { OverlayNosScreen } from './OverlayNosScreen';

export const DemoSwitchScreen = () => {
  const { activeOrganization } = useUser();

  const organizationId = activeOrganization?.id.toString() || '';
  const { links } = useCustomNavigate();
  const navigate = useNavigate();
  const { demoId, workspaceId } = useParams<{
    demoId: string;
    workspaceId: string;
  }>();
  const {
    data: demo,
    isLoading,
    error: demoError,
  } = useGetDemoQuery({
    workspaceId: workspaceId || '',
    organizationId,
    id: demoId || '',
  });

  if (!workspaceId) {
    navigate(-1);
    return null;
  }

  if (demoError) {
    return (
      <ErrorPage
        title="Error fetching demo"
        buttons={
          <Button
            label="Go to previous page"
            onClick={() => {
              navigate(-1);
            }}
          />
        }
      />
    );
  }

  if (isLoading || !demo) {
    return (
      <WorkspaceLayout>
        <div className="flex h-full items-center justify-center">
          <LoadingDots />
        </div>
      </WorkspaceLayout>
    );
  }

  if (demo?.isDeleted) {
    navigate(`${links.getWorkspaceLink(workspaceId)}/archive`);
  }

  return demo?.recordingType === RecordingTypes.overlay ? (
    <OverlayNosScreen demo={demo} />
  ) : (
    <DemoScreen demo={demo} />
  );
};
